import { apiRequest } from '@/services/http';
import type {
  EggTierView,
  EggView,
  HatchResultView,
  CollectionSummaryView,
  CreatureView,
  DailyCheckinResult,
  RewardsSummaryView,
} from '@/types/rewards';

// ── Egg tiers (reference data) ──────────────────────────────

function getEggTiers(): Promise<EggTierView[]> {
  return apiRequest<EggTierView[]>('/egg-tiers');
}

// ── Eggs (per reader) ───────────────────────────────────────

function getActiveEggs(readerId: string | number): Promise<EggView[]> {
  return apiRequest<EggView[]>(`/readers/${readerId}/eggs`);
}

function purchaseEgg(readerId: string | number, tierId: string): Promise<EggView> {
  return apiRequest<EggView>(`/readers/${readerId}/eggs`, {
    method: 'POST',
    body: { tierId },
  });
}

function hatchEgg(readerId: string | number, eggId: string): Promise<HatchResultView> {
  return apiRequest<HatchResultView>(`/readers/${readerId}/eggs/${eggId}/hatch`, {
    method: 'POST',
  });
}

// ── Creatures (per reader) ──────────────────────────────────

function getCollection(readerId: string | number): Promise<CollectionSummaryView> {
  return apiRequest<CollectionSummaryView>(`/readers/${readerId}/creatures`);
}

function getCreature(readerId: string | number, creatureId: string): Promise<CreatureView> {
  return apiRequest<CreatureView>(`/readers/${readerId}/creatures/${creatureId}`);
}

// ── Rewards summary ─────────────────────────────────────────

function getSummary(readerId: string | number): Promise<RewardsSummaryView> {
  return apiRequest<RewardsSummaryView>(`/readers/${readerId}/rewards/summary`);
}

// ── Daily checkin ───────────────────────────────────────────

function claimDaily(readerId: string | number): Promise<DailyCheckinResult> {
  return apiRequest<DailyCheckinResult>(`/readers/${readerId}/coins/daily`, {
    method: 'POST',
  });
}

export const rewardsService = {
  getEggTiers,
  getActiveEggs,
  purchaseEgg,
  hatchEgg,
  getCollection,
  getCreature,
  getSummary,
  claimDaily,
};
